import React, { Fragment, useState, useContext } from 'react'
import { Card, Grid, Sidebar } from 'semantic-ui-react'
import ExpertDetail from '../Sidebar'
import ExpertListTools from './ExpertListTools'
import ExpertCard from './ExpertCard'
import ExpertFilter from '../Filters/ExpertFilter'
import AddToProject from './Toolbox/AddToProject'
import InviteToProject from './Toolbox/InviteToProject'
import OnboardingForm from './Toolbox/OnboardingForm'
import OnboardingMessage from './Toolbox/OnboardingMessage'
import FilterTags from './Toolbox/FilterTags'
import InviteModal from '../Modals/ProjectInvite/InviteModal'
import Pagination from '../Pagination'
import { ExpertContext, SingleProjectContext } from '../../Context'
import './styles.css'

const Experts = () => {
    const singleProjectContext = useContext(SingleProjectContext)
    const { experts, currentPage, setCurrentPage, totalCount, perPage, jobs } =
        useContext(ExpertContext)

    const [userId, setUserId] = useState(null)
    const [showSidebar, setShowSidebar] = useState(false)
    const [showModal, setShowModal] = useState(false)
    const [isSelectAll, setIsSelectAll] = useState(false)
    const [selectedExperts, setSelectedExperts] = useState([])

    const onSelect = (expert) => {
        const selectedExpertIds = selectedExperts.map((expert) => expert.id)
        let typeIndex = selectedExpertIds.indexOf(expert.id)
        if (typeIndex === -1) selectedExperts.push(expert)
        else {
            selectedExperts.splice(typeIndex, 1)
        }
        setSelectedExperts(() => [...selectedExperts])
    }

    const onSelectAll = (project) => {
        if (isSelectAll) {
            setSelectedExperts([])
            setIsSelectAll(false)
        } else {
            setSelectedExperts(experts)
            setIsSelectAll(true)
        }
    }

    const { pathname } = window.location
    let type = 'EXPERT'
    if (pathname.includes('/projects')) {
        if (pathname.includes('/experts')) {
            type = 'SELECT_EXPERT'
        } else if (pathname.includes('/manage-experts')) {
            type = 'MANAGE_EXPERT'
        }
    }

    const project = singleProjectContext ? singleProjectContext.project : {}

    return (
        <Sidebar.Pushable>
            <Sidebar
                animation="overlay"
                onHide={() => setShowSidebar(false)}
                direction="right"
                visible={showSidebar}
                style={{ background: 'white', width: '50%', zIndex: 2999 }}
            >
                <ExpertDetail
                    userId={userId}
                    onSelect={onSelect}
                    selectedExperts={selectedExperts}
                />
            </Sidebar>
            {type === 'SELECT_EXPERT' && <OnboardingForm isSideForm={true} />}
            <Sidebar.Pusher>
                <div className={`${type === 'EXPERT' ? 'expert-box' : ''}`}>
                    <FilterTags />
                </div>
                <div className="project-experts-page">
                    <ExpertFilter type={type} />
                    <div className="experts-lower-section">
                        {type !== 'EXPERT' && (
                            <InviteModal
                                onShow={showModal}
                                onHide={() => setShowModal(false)}
                                experts={experts}
                                selectedExperts={selectedExperts}
                                setSelectedExperts={setSelectedExperts}
                                project={project}
                            />
                        )}
                        {type === 'SELECT_EXPERT' && (
                            <AddToProject
                                selectedExperts={selectedExperts}
                                setSelectedExperts={setSelectedExperts}
                                setShowModal={setShowModal}
                            />
                        )}
                        {type === 'MANAGE_EXPERT' && (
                            <Fragment>
                                <InviteToProject
                                    selectedExperts={selectedExperts}
                                    setSelectedExperts={setSelectedExperts}
                                    setShowModal={setShowModal}
                                    onSelectAll={onSelectAll}
                                    isSelectAll={isSelectAll}
                                    setIsSelectAll={setIsSelectAll}
                                    jobs={jobs}
                                />
                                <OnboardingMessage />
                            </Fragment>
                        )}
                        <ExpertListTools type={type} />
                        <Card.Group>
                            <Grid stackable columns={1}>
                                {type === 'SELECT_EXPERT' &&
                                experts.length === 0 ? (
                                    <OnboardingForm isSideForm={false} />
                                ) : (
                                    experts.map((expert, index) => {
                                        return (
                                            <Grid.Column key={index}>
                                                <ExpertCard
                                                    expert={expert}
                                                    setUserId={setUserId}
                                                    setShowSidebar={
                                                        setShowSidebar
                                                    }
                                                    selectedExperts={
                                                        selectedExperts
                                                    }
                                                    onSelect={onSelect}
                                                    type={type}
                                                    job={
                                                        jobs
                                                            ? jobs.filter(
                                                                  (j) =>
                                                                      j.user
                                                                          .id ===
                                                                      expert.id
                                                              )[0]
                                                            : null
                                                    }
                                                />
                                            </Grid.Column>
                                        )
                                    })
                                )}
                            </Grid>
                        </Card.Group>
                        <br />
                        <Pagination
                            defaultActivePage={currentPage}
                            totalPages={Math.ceil(totalCount / perPage)}
                            onPageChange={setCurrentPage}
                        />
                    </div>
                </div>
            </Sidebar.Pusher>
        </Sidebar.Pushable>
    )
}

export default Experts
